<tool-drawer-container [shouldShowToggleBtn]="false">
  <tool-header
    class="tool-header"
    headerTitle="Help Homepage"
    marginTop="30px"
  ></tool-header>

  <help-page-content class="main-content"></help-page-content>
</tool-drawer-container>
